import { render, staticRenderFns } from "./DexCloudModal.vue?vue&type=template&id=5bf36acc&scoped=true"
import script from "./DexCloudModal.vue?vue&type=script&lang=ts"
export * from "./DexCloudModal.vue?vue&type=script&lang=ts"
import style0 from "./DexCloudModal.vue?vue&type=style&index=0&id=5bf36acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf36acc",
  null
  
)

export default component.exports